import React, { useEffect, useState, useRef } from 'react' 
import {useNavigate, Link} from "react-router-dom";
import fb_logo from '../../icons/facebook_beige.svg'
import ig_logo from '../../icons/instagram_beige.svg'

import axios from 'axios';
const RestaurantContact = (props) => {
    const navigate = useNavigate();
    const igButtonRef = useRef();
    const fbButtonRef = useRef();
    const phoneAsText = `(${props.phone_number.substring(0,3)}) ${props.phone_number.substring(3, 6)}-${props.phone_number.substring(6,10)}`


    useEffect(() =>{
        if(props.ig_link == 'none'){
            igButtonRef.current.classList.add('hidden')
        }
        
        if(props.fb_link == 'none'){
            fbButtonRef.current.classList.add('hidden')
        }
    }, []);

    return (
        <div className='contact-info'>
                <ul className='contact-address'>
                    <li className='first-li'>
                        <Link to={props.gr_link} className='restaurant-location'>{props.restaurant_location}</Link>
                    </li>
                    <li>
                        <p className='restaurent-street-address'>{props.street_address}</p>
                    </li>
                    <li>
                        <p className='restaurant-city-address'>{props.city_address}</p>
                    </li>
                    <li>
                        <p className='restaurant-phone-number'>{phoneAsText}</p>
                    </li>
                </ul>
                <div className='contact-socials'>
                    <Link to={props.fb_link}><img ref={fbButtonRef} src={fb_logo} alt="" /></Link>
                    <Link to={props.ig_link}><img ref={igButtonRef} className='ig-logo' src={ig_logo} alt="" /></Link>
                </div>
        </div>
    )
}
export default RestaurantContact;
